import { IDefineOptionsValues } from '@/types/api/pricings';

export const DaysOptions = {
  five: '5 dias',
  ten: '10 dias',
  twenty: '20 dias',
  thirty: '30 dias',
} as const;

export const generateTimeOptions = (days: string): IDefineOptionsValues[] => {
  return [
    {
      id: 1,
      value: 'define',
      name: !(Object.values(DaysOptions) as string[]).includes(days)
        ? days
        : 'Definir',
      selected:
        !(Object.values(DaysOptions) as string[]).includes(days) &&
        days !== 'Definir',
    },
    {
      id: 2,
      value: 5,
      name: DaysOptions.five,
      selected: days === DaysOptions.five,
    },
    {
      id: 3,
      value: 10,
      name: DaysOptions.ten,
      selected: days === DaysOptions.ten,
    },
    {
      id: 4,
      value: 20,
      name: DaysOptions.twenty,
      selected: days === DaysOptions.twenty,
    },
    {
      id: 5,
      value: 30,
      name: DaysOptions.thirty,
      selected: days === DaysOptions.thirty,
    },
  ];
};

export function getUpdatedInputNumberOfDays(newValue: number) {
  return newValue > 1 ? `${newValue} dias` : newValue === 1 ? '1 dia' : 'hoje';
}
